import FilterDropDown from 'components/FilterDropDown';
import classNames from './view-job.module.css';
import {until} from 'helpers/helpers';
import {Loading, draftJsUtils, TextEditor} from 'erp-react-components';
import {useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import toastService from 'components/Toasts/toast-service';
import JobBoardMenu from 'components/JobboradMenu';
import Styles from '../job-board-list/internal-job-list.module.css';
import {Trans, useTranslation} from 'react-i18next';
import JobBoardMenuMobileView from 'components/JobboradMenu/job-board-menu-mobile-view';
import {getAPI} from 'data.api';
import {stateToHTML} from 'draft-js-export-html';
import {Col, Row} from 'react-bootstrap';

const {convertFromRaw, EditorState} = draftJsUtils;

const ViewJob = () => {
  const {t} = useTranslation();
  const history = useHistory();
  const {postId} = useParams();
  const [viewDeails, setviewDeails] = useState<any>([]);
  const [isLoading, setisLoading] = useState(false);
  const historyState = history?.location?.state?.ViewJob || '';

  useEffect(() => {
    getViewDetails();
  }, []);

  function getEditorStateorText(editortext) {
    let content = editortext ? editortext : '';
    try {
      content = JSON.parse(editortext || '{}')['draftjs-object'];
    } catch (e) {
      console.error(e);
    }
    return content
      ? EditorState.createWithContent(convertFromRaw(content))
      : EditorState.createEmpty();
  }

  function checkContentExist(editorStateText) {
    if (editorStateText) {
      const content = JSON.parse(editorStateText || '{}')['draftjs-object'];
      return (
        content &&
        EditorState.createWithContent(convertFromRaw(content))
          .getCurrentContent()
          .hasText()
      );
    }
  }

  async function getViewDetails() {
    if (postId) {
      const query = `jobs/${postId}/job-details`;
      setisLoading(true);
      const [err, res] = await until(getAPI(query));
      setisLoading(false);
      if (err) {
        setviewDeails(null);
        toastService.error({msg: err.message});
        return console.error(err);
      }
      if (res?.success) setviewDeails(res?.data);
    }
  }

  function handleRedirectList(type) {
    if (type === 'view') {
      history.push({
        pathname: !history?.location?.state?.apply
          ? `/internal/jobboard`
          : `/jobboard/applied`,
      });
    } else {
      history.push({
        pathname: `/internal/applyjob/${
          historyState?.position_number || viewDeails?.position_number
        }`,
        state: {
          ViewJob: historyState?.hiring_request
            ? {
                ...historyState?.hiring_request,
                role: historyState?.job_role,
              }
            : historyState
            ? historyState
            : viewDeails,
          postId: historyState?.position_number || viewDeails?.position_number,
        },
      });
    }
  }

  const handleContent = (content) => {
    if (typeof content === 'string') {
      try {
        const parsedContent = JSON.parse(content);
        if (parsedContent && parsedContent['draftjs-object']) {
          const contentState = convertFromRaw(parsedContent['draftjs-object']);
          const editorState = EditorState.createWithContent(contentState);
          const html = stateToHTML(editorState.getCurrentContent());
          return html;
        }
      } catch (error) {
        return content;
      }
    }
    return content;
  };
  return (
    <>
      <div>
        <FilterDropDown
          dropdown={false}
          viewJob={historyState || viewDeails}
          module={
            !history?.location?.state?.apply ? 'view-job' : 'view-application'
          }
        />
      </div>
      <div className={` ${classNames['internal-job-container']}`}>
        <div className={Styles['internal-job-sub-container']}>
          <div className={Styles['internal-job-info-container']}>
            <div className={Styles['internal-job-info']}>
              <JobBoardMenu active={'search-job'} />
            </div>
          </div>{' '}
          {!isLoading && viewDeails ? (
            <div className={Styles['job-board-list-container']}>
              {viewDeails ? (
                <div
                  className={`awl-custom-scroll ${Styles['internal-job-list']}`}
                >
                  <div className={classNames['view-job-summary']}>
                    <Row>
                      <Col>
                        <label className="label-basic">
                          {t('View_Job_Academic Qualifications')}
                        </label>
                      </Col>
                    </Row>
                    <Row>
                      {viewDeails?.job_desc_detail?.job_qualifications && (
                        <Col sm="auto">
                          <label className="awl-form-group-label">
                            {t('Education')}
                          </label>
                          <div className={classNames.grayWhiteBgValue}>
                            {
                              viewDeails?.job_desc_detail?.job_qualifications
                                ?.education
                            }
                          </div>
                        </Col>
                      )}
                      {viewDeails?.job_desc_detail?.job_qualifications && (
                        <Col sm="auto">
                          <label className="awl-form-group-label">
                            {t('View_Job_Field of Study')}
                          </label>
                          <div className={classNames.grayWhiteBgValue}>
                            {
                              viewDeails?.job_desc_detail?.job_qualifications
                                ?.field_of_study
                            }
                          </div>
                        </Col>
                      )}
                    </Row>
                  </div>
                  {viewDeails?.job_desc_detail?.job_skills ? (
                    <div className={classNames['view-job-summary']}>
                      <Row>
                        <Col>
                          <label className="label-basic">{t('Skills')}</label>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {viewDeails?.job_desc_detail?.job_skills
                            ?.mandatory ? (
                            <>
                              <label className="awl-form-group-label">
                                {t('Required')}
                              </label>
                              <div className={classNames.grayWhiteBgValue}>
                                {viewDeails?.job_desc_detail?.job_skills
                                  ?.mandatory || ''}
                              </div>
                            </>
                          ) : (
                            <></>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {viewDeails?.job_desc_detail?.job_skills
                            ?.prefered && (
                            <>
                              <label className="awl-form-group-label mt-3">
                                {t('View_Job_Preferred')}
                              </label>
                              <div className={classNames.grayWhiteBgValue}>
                                {viewDeails?.job_desc_detail?.job_skills
                                  ?.prefered || ''}
                              </div>
                            </>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {viewDeails?.job_desc_detail?.job_skills
                            ?.good_to_have && (
                            <>
                              <label className="awl-form-group-label mt-3">
                                {t('Good to have')}
                              </label>
                              <div className={classNames.grayWhiteBgValue}>
                                {viewDeails?.job_desc_detail?.job_skills
                                  ?.good_to_have || ''}
                              </div>
                            </>
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {viewDeails?.language && (
                            <>
                              <label className="awl-form-group-label mt-3">
                                {t('Language')}
                              </label>
                              <div className={classNames.grayWhiteBgValue}>
                                {viewDeails?.language?.name || ''}
                              </div>
                            </>
                          )}
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <></>
                  )}
                  {viewDeails?.job_desc_detail?.description &&
                  checkContentExist(
                    viewDeails?.job_desc_detail?.description,
                  ) ? (
                    <div className={classNames['view-job-summary']}>
                      <div className="mb-2">
                        <strong>{t('Summary')}</strong>
                      </div>
                      <div className={classNames.grayWhiteBgValue}>
                        {/* <TextEditor
                          editorState={getEditorStateorText(
                            viewDeails?.description || '',
                          )}
                          readOnly={true}
                        /> */}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: handleContent(
                              viewDeails?.job_desc_detail?.description,
                            ),
                          }}
                        ></div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {viewDeails?.job_desc_detail?.roles_responsibilities &&
                  checkContentExist(
                    viewDeails?.job_desc_detail?.roles_responsibilities,
                  ) ? (
                    <div className={classNames['view-job-summary']}>
                      <div className="mb-2">
                        <strong>{t(`What you'll be doing`)}</strong>
                      </div>
                      {/* <div className="mb-2">
                        <strong>{t(`Roles & Responsibilities`)}</strong>
                      </div> */}
                      <div className={classNames.grayWhiteBgValue}>
                        {/* <TextEditor
                          editorState={getEditorStateorText(
                            viewDeails?.job_desc_detail
                              ?.roles_responsibilities || '',
                          )}
                          readOnly={true}
                        /> */}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: handleContent(
                              viewDeails?.job_desc_detail
                                ?.roles_responsibilities,
                            ),
                          }}
                        ></div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {viewDeails?.job_desc_detail?.about_job &&
                  checkContentExist(viewDeails?.job_desc_detail?.about_job) ? (
                    <div className={classNames['view-job-summary']}>
                      <div className="mb-2">
                        <strong
                          className={classNames['view-job-summary-title']}
                        >
                          {t(`What we're looking for`)}
                        </strong>
                      </div>
                      <div className={classNames.grayWhiteBgValue}>
                        {/* <TextEditor
                          editorState={getEditorStateorText(
                            viewDeails?.job_desc_detail?.about_job || '',
                          )}
                          readOnly={true}
                        /> */}
                        <div
                          dangerouslySetInnerHTML={{
                            __html: handleContent(
                              viewDeails?.job_desc_detail?.about_job,
                            ),
                          }}
                        ></div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {viewDeails?.job_desc_detail?.about_team_comapany &&
                  checkContentExist(
                    viewDeails?.job_desc_detail?.about_team_comapany,
                  ) ? (
                    <div className={classNames['view-job-summary']}>
                      <div className="mb-2">
                        <strong
                          className={classNames['view-job-summary-title']}
                        >
                          {t(`What's in it for you`)}
                        </strong>
                      </div>
                      <div className={classNames.grayWhiteBgValue}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: handleContent(
                              viewDeails?.job_desc_detail?.about_team_comapany,
                            ),
                          }}
                        ></div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className={classNames['view-job-summary']}>
                    <label className="label-basic">
                      {t('View_Job_About PTW')}
                    </label>
                    <div className={`${classNames.grayWhiteBgValue}`}>
                      <div className={`mt-2 ${classNames['about-text']}`}>
                        {
                          <>
                            <Trans
                              i18nKey={'View_Job_aboutPTWparagraph1'}
                              t={t}
                              defaults={`<1>PTW is a boutique games services company that
                                  provides custom solutions worldwide. We
                                  believe in accelerating innovation across the
                                  globe. We started more than 25 years ago and
                                  since then, have grown exponentially
                                  year-on-year to who we are today. Our history
                                  is in gaming, and we are still gamers at
                                  heart. In our time within the games industry,
                                  we have worked on over 1,500 titles across all
                                  genres and all platforms.</1>`}
                              components={{
                                1: <p className="mb-2 " />,
                              }}
                            />
                            <Trans
                              i18nKey={'View_Job_aboutPTWparagraph2'}
                              t={t}
                              defaults={`<1>We have grown rapidly over the past few years
                                  and now have 16 sites spanning the globe. The
                                  PTW umbrella of companies includes SIDE, 1518,
                                  OR Esports, and Entalize. SIDE works at the
                                  cutting edge of interactive media as a
                                  provider of audio services for the global
                                  entertainment market. 1518 is known industry
                                  wide for world-class art and is also our
                                  in-house game and product development studio.</1>`}
                              components={{
                                1: <p className="mb-2 " />,
                              }}
                            />
                            <Trans
                              i18nKey={'View_Job_aboutPTWparagraph3'}
                              t={t}
                              defaults={`<1>Basically, anywhere in the world, any
                                  platform, any genre, we can help come up with
                                  a custom solution to make games run better,
                                  get to market faster, and enhance the lives of
                                  more players.</1>`}
                              components={{
                                1: <p className="mb-2 " />,
                              }}
                            />
                            <Trans
                              i18nKey={'View_Job_aboutPTWline3'}
                              t={t}
                              defaults={`<1>In summary, we connect and bring fun to the world.</1>`}
                              components={{
                                1: <p className="mb-2 " />,
                              }}
                            />
                            <Trans
                              i18nKey={'View_Job_aboutPTWline4'}
                              t={t}
                              defaults={`<1>Welcome to PTW, Family of Brands</1>`}
                              components={{
                                1: <p className="mb-2 " />,
                              }}
                            />
                          </>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={classNames['no-record']}>
                  {t('Records Not Found')}
                </div>
              )}
              <div className={classNames['view-job-btns']}>
                <button
                  className={classNames['view-btn']}
                  onClick={() => handleRedirectList('view')}
                >
                  {t('View_application_Back')}
                </button>
                {!history?.location?.state?.apply ? (
                  <button
                    className={`ml-2 ${classNames['apply-btn']}`}
                    onClick={() => handleRedirectList('apply')}
                  >
                    {t('Apply')}
                  </button>
                ) : (
                  <></>
                )}
              </div>
            </div>
          ) : !isLoading && !viewDeails ? (
            <div className={classNames['no-record']}>
              {t('Records Not Found')}
            </div>
          ) : (
            <Loading />
          )}
        </div>
      </div>
      <div className={Styles['menu-item-mv']}>
        <JobBoardMenuMobileView active={'search-job'} />
      </div>
    </>
  );
};

export default ViewJob;
